import type { ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";

type SiteLayoutProps = {
  children: ReactNode;
  fullBleedTop?: boolean;
};

export default function SiteLayout({ children, fullBleedTop = false }: SiteLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className={`flex-1 ${fullBleedTop ? "" : "pt-16 md:pt-[68px]"}`}>{children}</main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}